module.exports = __webpack_public_path__ + "static/media/h2.569d46c4.png";